import React, { FC, ReactNode } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Fade } from "@mui/material";
import { t } from "i18next";

import {
  CustomModal,
  ModalContent,
  CloseButton,
  ButtonContainer,
} from "./ConfirmationModal.styled";

import { Box, Button, Typography } from "@components/base";

interface ConfirmationModal {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string | ReactNode;
  description?: string | ReactNode;
  isLoading?: boolean;
  cancelText?: string;
  confirmText?: string;
  confirmDisabled?: boolean;
  noCancel?: boolean;
}

const ConfirmationModal: FC<ConfirmationModal> = ({
  open,
  onClose,
  onConfirm,
  title,
  isLoading = false,
  description,
  cancelText = t("common.cancel"),
  confirmText = t("common.confirm"),
  confirmDisabled = false,
  noCancel = false,
}) => {
  return (
    <CustomModal open={open} onClose={noCancel ? undefined : onClose}>
      <Fade in={open} timeout={300}>
        <ModalContent>
          {!noCancel && (
            <CloseButton onClick={onClose}>
              <CloseIcon fontSize="inherit" />
            </CloseButton>
          )}
          <Box textAlign="center" gap={2}>
            <Typography component="div" variant="h6">
              {title}
            </Typography>
            {description && (
              <Typography
                textAlign="center"
                component="div"
                variant="body1"
                color="textSecondary"
              >
                {description}
              </Typography>
            )}
          </Box>
          <ButtonContainer>
            {!noCancel && (
              <Button variant="outlined" size="medium" onClick={onClose}>
                {cancelText}
              </Button>
            )}
            <Button
              size="medium"
              onClick={onConfirm}
              disabled={confirmDisabled}
              isLoading={isLoading}
            >
              {confirmText}
            </Button>
          </ButtonContainer>
        </ModalContent>
      </Fade>
    </CustomModal>
  );
};

export default ConfirmationModal;
